import AxiosInstanceCreator from 'services/api';
const authInstance = new AxiosInstanceCreator().create();

export const frsApi = {
  async getFrsUserList() {
    return await authInstance.post(`/biostar/user-list`).then((res) => res.data);
  }
};
